import React, { useEffect, useRef } from "react";
import ClipLoader from "react-spinners/ClipLoader";

export const TabMenuLargerComp = ({
  handleTabClick,
  activeTab,
  tabs,
  loadingData = false,
}) => {
  const tabsRef = useRef(null);
  const itemRef = useRef();
  useEffect(() => {
    // Prevent click event when dragging horizontally
    const tabsElement = tabsRef.current;
    if (tabsElement) {
      let isDown = false;
      let startX;
      let scrollLeft;
      let handleMouseMove; // Lưu trữ hàm xử lý sự kiện

      const onMouseDown = (e) => {
        isDown = true;
        startX = e.pageX - tabsElement.offsetLeft;
        scrollLeft = tabsElement.scrollLeft;
      };
      const onMouseLeave = () => {
        isDown = false;
        startX = 0;
        scrollLeft = 0;
      };
      const onMouseUp = () => {
        isDown = false;
        startX = 0;
        scrollLeft = 0;
      };
      handleMouseMove = (e) => {
        // Gán hàm xử lý sự kiện vào biến handleMouseMove
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - tabsElement.offsetLeft;
        const walk = (x - startX) * 2; // Adjust scroll speed if necessary
        tabsElement.scrollLeft = scrollLeft - walk;
      };

      tabsElement.addEventListener("wheel", (e) => {
        e.preventDefault();
        // e.stopPropagation()
        tabsElement.scrollLeft = tabsElement.scrollLeft + e.deltaY * 2;
      });
      tabsElement.addEventListener("mousedown", onMouseDown);
      tabsElement.addEventListener("mouseleave", onMouseLeave);
      tabsElement.addEventListener("mouseup", onMouseUp);
      tabsElement.addEventListener("mousemove", handleMouseMove); // Sử dụng biến handleMouseMove

      return () => {
        // Cleanup event listeners if component unmounts

        tabsElement.removeEventListener("mousedown", onMouseDown); // Sử dụng hàm xử lý đã được lưu trữ
        tabsElement.removeEventListener("mouseleave", onMouseLeave);
        tabsElement.removeEventListener("mouseup", onMouseUp);
        tabsElement.removeEventListener("mousemove", handleMouseMove); // Sử dụng biến handleMouseMove
      };
    }
  }, [activeTab]);

  return (
    <div
      style={{
        alignItems: "center",
        justifyContent: "space-between",
        overflow: "hidden",
        flexWrap: "nowrap",
        position: "relative",
        whiteSpace: "nowrap",
        width: "100%",
      }}
    >
        {tabs.map((tab) => (
          <div
            key={tab.value}
            id={tab.value === activeTab ? "active" : null}
            className={"col-md-3 "+ (tab.value === activeTab ? "active " : "")}
            style={{
              position: tab.value === activeTab ? "sticky" : "",
              zIndex: tab.value === activeTab ? "2" : "1",
              //backgroundColor: tab.color,
              boxShadow: tab.value === activeTab && "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              padding: "30px",
              textAlign: "center",
              justifyContent: "center",
              float: "left",
              borderTop: tab.value === activeTab && "3px solid #29a745",
              cursor: "pointer",
              backgroundColor:tab.value === activeTab ? "#00884e29" : "#bbb3b321",
              borderLeft: "1px solid #dddddd66",
              borderRight: "1px solid #dddddd66",
            }}
            onClick={() => {
              handleTabClick(tab.value);
            }}
            ref={itemRef}
          >
            <i className={tab.icon} style={{ color: tab.color, marginRight:"5px",fontSize:"25px" }}></i>
            {tab.label}
            <br /> <span className="red ">{tab.count}</span>
            {loadingData && tab.value === activeTab && (
              <ClipLoader
                color="#029047"
                size={20}
                cssOverride={{ animation: "clipload 1s linear infinite" }}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            )}
          </div>
        ))}
    </div>
  );
};

export const TabMenuLarger = React.memo(TabMenuLargerComp);
